<template>
    <section id="capacities" class="ct">
      <div class="ct__inner">
        <!-- <h2 class="ct__title">Capacités & configurations</h2> -->
        <div class="ct__scroll">
          <table class="ct__table" role="table" aria-label="Capacités et configurations">
            <thead>
              <tr>
                <th class="ct__head ct__head--label"> </th>
                <th v-for="(col, i) in cols" :key="`h-${i}`" class="ct__head">
                  <span class="ct__icon" v-html="iconSvg(col)"></span>
                  <span class="ct__headLabel raleway-semi-p12">{{ col }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, r) in rows" :key="`r-${r}`">
                <th class="ct__room raleway-semi-p15">{{ row.label }}</th>
                <td v-for="(val, c) in (row.cells || [])" :key="`r-${r}-c-${c}`" class="ct__cell raleway-reg-p15">
                  {{ val && String(val).length ? val : '–' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </template>
  <script>
  export default {
    name: 'CapacityTableSection',
    props: {
      table: {
        type: Object,
        default: () => ({
          columns: [
            'SURFACE','CONFÉRENCE','ATELIER','BANQUET','EN « U »','EN CARRÉ','DEMI-LUNE','COCKTAIL'
          ],
          rows: [
            { label: "L’ATELIER",            cells: Array(8).fill('') },
            { label: "SALLE DE TECHNOLOGIE", cells: Array(8).fill('') },
            { label: "ATELIER 1",            cells: Array(8).fill('') },
            { label: "ATELIER 2",            cells: Array(8).fill('') },
            { label: "COUR EXTÉRIEURE",      cells: Array(8).fill('') }
          ]
        })
      }
    },
    computed: {
      cols() {
        return Array.isArray(this.table?.columns) ? this.table.columns : [];
      },
      rows() {
        return Array.isArray(this.table?.rows) ? this.table.rows : [];
      }
    },
    methods: {
      iconSvg(label) {
        const key = (label || '').toString().toLowerCase();
        const svgs = {
          'surface':        '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#305F52" stroke-width="1.5"><rect x="4" y="6" width="16" height="12" rx="2"/><path d="M4 10h16"/></svg>',
          'conférence':     '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#305F52" stroke-width="1.5"><circle cx="6" cy="8" r="2"/><circle cx="12" cy="8" r="2"/><circle cx="18" cy="8" r="2"/><path d="M4 18c0-2 1.5-3 3-3s3 1 3 3"/><path d="M10 18c0-2 1.5-3 3-3s3 1 3 3"/></svg>',
          'atelier':        '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#305F52" stroke-width="1.5"><path d="M3 20h18M6 20V8l6-4 6 4v12"/></svg>',
          'banquet':        '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#305F52" stroke-width="1.5"><path d="M4 12h16M6 20l2-8m8 8l-2-8"/></svg>',
          'en « u »':       '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#305F52" stroke-width="1.5"><path d="M4 6v6a6 6 0 006 6h4a6 6 0 006-6V6"/></svg>',
          'en carré':       '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#305F52" stroke-width="1.5"><rect x="5" y="5" width="14" height="14" rx="2"/></svg>',
          'demi-lune':      '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#305F52" stroke-width="1.5"><path d="M4 18a8 8 0 0116 0"/></svg>',
          'cocktail':       '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#305F52" stroke-width="1.5"><path d="M5 5h14l-7 7-7-7z"/><path d="M12 12v6"/><path d="M9 21h6"/></svg>'
        };
  
        for (const k in svgs) {
          if (key.includes(k)) return svgs[k];
        }
        return '';
      }
    }
  };
  </script>
  
  <style>
  .ct { background:#fff; padding: clamp(28px, 5vw, 56px) clamp(16px, 3vw, 24px); }
  .ct__inner { max-width: 1200px; margin: 0 auto; }
  .ct__title {
    /* font-family: Georgia, serif; */
    font-weight: 700;
    font-size: clamp(22px, 3vw, 32px);
    margin: 0 0 clamp(18px, 2.2vw, 24px);
    text-align: left;
    font-family: 'Raleway', sans-serif;
  }
  
  .ct__scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 10px;
    border: 1px solid #e6edea;
    background: #f6fbf9;
  }
  
  @media (min-width: 980px) {
    .ct__scroll { overflow: visible; }
  }
  
  .ct__table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 980px;
  }
  
  .ct__head {
    text-align: center;
    padding: 14px 10px 10px;
    background: #f2f8f5;
    color: #305F52;
    font-weight: 700;
    font-size: 12px;
    font-family: 'Raleway', sans-serif;
    text-transform: uppercase;
    letter-spacing: .02em;
    border-bottom: 1px solid #e6edea;
  }
  
  .ct__head--label { width: 220px; text-align: left; background:#2e5f54; color:#fff; }
  .ct__icon { display:block; margin: 0 auto 6px; height: 28px; width: 28px; }
  .ct__headLabel { display:block; white-space: nowrap; }
  
  .ct__room {
    position: sticky; left: 0; z-index: 1;
    background: #3f6f64; color:#fff;
    padding: 14px 16px;
    border-bottom: 1px solid rgba(255,255,255,.12);
    min-width: 220px;
  }
  
  .ct__cell {
    text-align: center;
    padding: 14px 12px;
    background: #f6fbf9;
    border-left: 1px solid #e6edea;
    border-bottom: 1px solid #e6edea;
    min-width: 120px;
  }
  
  tbody tr:nth-child(odd) .ct__cell { background:#eef6f2; }
  </style>  